module.exports = __webpack_public_path__ + "static/media/Ken_B.29c44bd5.jpg";